import { isQuarterPoint, QUARTER_MESSAGE, weekGoalError } from "@/lib/points";
import type { WorkoutLogConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";

function partGoalError(goal: number | undefined, name: string) {
  if (goal === undefined || !Number.isFinite(goal)) {
    return `Ukesmål for ${name} kreves.`;
  }
  if (goal <= 0) return `Ukesmål for ${name} må være over 0.`;
  if (!isQuarterPoint(goal)) return QUARTER_MESSAGE;
  return undefined;
}

export function validate(config: WorkoutLogConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (config.points < 1) {
    errors.points = "Poeng må være minst 1.";
  }
  const { planning } = config;
  if (!planning) {
    // No upper bound on weekGoal — the weekly max is unbounded (docs/adr/0003).
    const goalError = weekGoalError(config.weekGoal);
    if (goalError) errors.weekGoal = goalError;
  } else {
    // Two Scorable parts, each with its own goal (docs/adr/0010); the
    // instance's `weekGoal` is their sum, written by the editor.
    if (!Number.isFinite(planning.points) || planning.points < 1) {
      errors.planningPoints = "Poeng for planlegging må være minst 1.";
    }
    const workoutsError = partGoalError(config.workoutsWeekGoal, "økter");
    if (workoutsError) errors.workoutsWeekGoal = workoutsError;
    const planningError = partGoalError(planning.weekGoal, "planlegging");
    if (planningError) errors.planningWeekGoal = planningError;
    if (
      !workoutsError &&
      !planningError &&
      config.weekGoal !== (config.workoutsWeekGoal ?? 0) + planning.weekGoal
    ) {
      errors.weekGoal = "Samlet ukesmål må være summen av de to delmålene.";
    }
  }
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
